import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ContentListing from "@/pages/ContentListing";
const ContentListingRoute = () => <ContentListing contentType="white_papers" pageTitle="Descargas" pageDescription="Documentos técnicos, guías y evaluaciones de preparación sobre estrategia regulatoria, gestión de calidad y cumplimiento en la industria de Life Sciences." />;

export const Route = createFileRoute("/es/downloads/")({
  head: () => buildRouteHead("/es/downloads"),
  component: ContentListingRoute,
});

